import React, { useEffect, useRef } from 'react';

const MapPicker = ({ initialLat = 7.8806, initialLng = 98.3923, onChange }) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const mapInstanceRef = useRef(null);

  useEffect(() => {
    const initMap = () => {
      if (!mapRef.current) return;

      // สร้าง map
      const map = new window.google.maps.Map(mapRef.current, {
        center: { lat: initialLat, lng: initialLng },
        zoom: 12,
      });

      mapInstanceRef.current = map;

      // สร้าง marker
      const marker = new window.google.maps.Marker({
        position: { lat: initialLat, lng: initialLng },
        map,
        draggable: true,
      });

      // ลาก marker
      marker.addListener('dragend', () => {
        const pos = marker.getPosition();
        onChange({ lat: pos.lat(), lng: pos.lng() });
      });

      // คลิก map
      map.addListener('click', (e) => {
        const pos = { lat: e.latLng.lat(), lng: e.latLng.lng() };
        marker.setPosition(pos);
        onChange(pos);
      });

      markerRef.current = marker;
    };

    if (!window.google) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDQJsMZLZqlWRUAmS_4zNPhawYKFsB55AU`;
      script.async = true;
      script.onload = initMap;
      document.head.appendChild(script);
    } else {
      initMap();
    }
  }, []); // ❌ ไม่ต้องใส่ initialLat/initialLng เพราะเราจะอัปเดต marker แยก

  // อัปเดต marker ถ้า parent เปลี่ยนค่า
  useEffect(() => {
    if (markerRef.current) {
      const pos = { lat: initialLat, lng: initialLng };
      markerRef.current.setPosition(pos);
      if (mapInstanceRef.current) mapInstanceRef.current.setCenter(pos);
    }
  }, [initialLat, initialLng, onChange]);

  return <div ref={mapRef} style={{ width: '100%', height: '300px' }} />;
};

export default MapPicker;
